import {Theme} from '@labshare/base-ui/theme';

export const labshare: Theme = {
  name: 'labshare',
  extend: 'default',
  properties: {
    'main-background-color': '#ffffff',
    'header-background-color': 'rgb(250,250,250)'
  }
};
